import { render, staticRenderFns } from "./formDesigner.vue?vue&type=template&id=50025668&scoped=true&"
import script from "./formDesigner.vue?vue&type=script&lang=js&"
export * from "./formDesigner.vue?vue&type=script&lang=js&"
import style0 from "./formDesigner.vue?vue&type=style&index=0&id=50025668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50025668",
  null
  
)

component.options.__file = "formDesigner.vue"
export default component.exports